// import request from './huddle-request';

const methods = ({ request }) => ({

  // expects a single playerId and an array of formulas
  putTracking: async (playerId, formulas) =>
    request(`User/Tracking/${playerId}`, { method: 'PUT', body: formulas }),

  // expects an array of {playerid, formulas[]} objects
  postTracking: async trackList =>
    trackList && request('User/Tracking', { method: 'POST', body: trackList }),

  deleteTracking: async playerId =>
    request(`User/Tracking/${playerId}`, { method: 'DELETE' }),
  
  deleteLeagueTracking: async (playerId, formulas) =>
    request(`User/Tracking/${playerId}`, { method: 'DELETE', body: formulas }),

  // /User/Tracking
  // GET, *PUT, POST, *DELETE
  getAll: async () => request('User/Tracking'),

});

export default methods;



// WEBPACK FOOTER //
// ./src/lib/api/tracking.js